import { render, staticRenderFns } from "./OperationCounterTab.vue?vue&type=template&id=94785064&scoped=true"
import script from "./OperationCounterTab.vue?vue&type=script&lang=js"
export * from "./OperationCounterTab.vue?vue&type=script&lang=js"
import style0 from "./OperationCounterTab.vue?vue&type=style&index=0&id=94785064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94785064",
  null
  
)

export default component.exports